// Resolve the visitor's country from Shopify's own geolocation endpoint, then upgrade any
// server-rendered market country on the page (announcement bar, PDP USPs, cart drawer, etc.)
// to the real one. The lookup runs once per page load and the result is cached, then applied
// to any matching element — including ones that appear later via AJAX re-renders.

let detectedCountryPromise = null;

function resolveDetectedCountry() {
  if (!detectedCountryPromise) {
    detectedCountryPromise = (async () => {
      const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
      const response = await fetch(`${root}browsing_context_suggestions.json?country%5Benabled%5D=true`);
      if (!response.ok) return null;

      const data = await response.json();
      const detected = data && data.detected_values && data.detected_values.country;
      if (!detected || !detected.handle) return null;

      return { code: detected.handle, name: detected.name || data.detected_values.country_name };
    })().catch(() => null); // keep the Liquid-rendered market country on failure
  }
  return detectedCountryPromise;
}

async function applyDetectedCountry(root) {
  const nameElements = root.querySelectorAll('[data-detected-country-name]');
  const flagElements = root.querySelectorAll('[data-detected-country-flag]');
  if (!nameElements.length && !flagElements.length) return;

  const country = await resolveDetectedCountry();
  if (!country) return;

  nameElements.forEach((element) => (element.textContent = country.name));
  flagElements.forEach((element) => {
    element.setAttribute('aria-label', country.name);
    const sprite = element.firstElementChild;
    if (!sprite) return;
    sprite.className = `country-flags country-flags--${country.code}`;
  });
}

// Watch for elements added after the initial load (cart drawer re-renders, quick add, upsells, ...)
// so they get upgraded too, without triggering another API call.
function observeDetectedCountry() {
  const observer = new MutationObserver((mutations) => {
    for (const mutation of mutations) {
      mutation.addedNodes.forEach((node) => {
        if (node.nodeType !== Node.ELEMENT_NODE) return;
        if (node.matches?.('[data-detected-country-name], [data-detected-country-flag]')) {
          applyDetectedCountry(node.parentElement || document);
        }
        if (node.querySelector?.('[data-detected-country-name], [data-detected-country-flag]')) {
          applyDetectedCountry(node);
        }
      });
    }
  });
  observer.observe(document.body, { childList: true, subtree: true });
}

function init() {
  applyDetectedCountry(document);
  observeDetectedCountry();
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', init);
} else {
  init();
}
